import { useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const ZoomParallax = ({ src, alt, className = "", imgClassName = "" }) => {
  const ref = useRef(null);
  const [loaded, setLoaded] = useState(false);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.18]);

  return (
    <div ref={ref} className={`relative overflow-hidden bg-[#EDE6DA] ${className}`}>
      {!loaded && (
        <div
          className="absolute inset-0 animate-pulse bg-gradient-to-br from-[#F3E5AB]/35 via-[#EFE7DB] to-[#E5DACB]"
          aria-hidden="true"
        />
      )}
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        onLoad={() => setLoaded(true)}
        style={{ scale }}
        className={`h-full w-full object-cover transition-[opacity,filter] duration-700 ease-out ${
          loaded ? "opacity-100 blur-0" : "opacity-0 blur-md"
        } ${imgClassName}`}
      />
    </div>
  );
};
